import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './plugins/firebase'
import './plugins/moment'
import './plugins/filters'
import './plugins/axios'
import sentryPlugin from './plugins/sentry'
import serviceSingletonsPlugin from './plugins/service-singletons'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import NoHeaderLayout from '@/layouts/NoHeaderLayout.vue'

if (process.env.VUE_APP_SENTRY_DSN) {
  Vue.use(sentryPlugin, {
    dsn: process.env.VUE_APP_SENTRY_DSN,
    env: process.env.VUE_APP_ENV
  })
}

Vue.use(serviceSingletonsPlugin)

Vue.config.productionTip = false

Vue.component('default-layout', DefaultLayout)
Vue.component('no-header-layout', NoHeaderLayout)

/*Vue.use(VueTagManager, {gtmId: process.env.VUE_APP_GOOGLE_TAG_MANAGER})*/

new Vue({
  router, store, vuetify,
  render: (h) => h(App)
}).$mount('#app')
